import { useState } from 'react';
import { TextField, TextFieldProps } from '@mui/material';

type DeferredTextFieldProps = Omit<TextFieldProps, 'value' | 'onChange' | 'onBlur' | 'onFocus'> & {
  value: string;
  onCommit: (value: string) => void;
  suggestion?: () => string;
  // Limite de saisie, affichée sous le champ avec le nombre de caractères restants
  maxLength?: number;
};

function DeferredTextField({ value, onCommit, suggestion, maxLength, ...props }: DeferredTextFieldProps) {
  const [draft, setDraft] = useState(value);

  return (
    <TextField
      fullWidth
      size="small"
      InputLabelProps={{ shrink: true }}
      {...props}
      {...(maxLength !== undefined && {
        inputProps: { ...props.inputProps, maxLength },
        helperText: props.helperText ?? `${draft.length} / ${maxLength} caractères`,
      })}
      value={draft}
      onFocus={() => { if (!draft && suggestion) setDraft(suggestion()); }}
      onChange={e => setDraft(e.target.value)}
      onBlur={e => onCommit(e.target.value)}
    />
  );
}

export default DeferredTextField;
